import { loginApi } from "../services/authApi";
import { LOGIN_ERROR, LOGIN_SUCCESS, SET_USER } from "../types";

export const loginAction = (body) => async (dispatch) => {
    try {
        const response = await loginApi(body);
        console.log(response);
        
        const token = response.data.result;
        localStorage.setItem("token", token);
        
        dispatch({
            type: LOGIN_SUCCESS,
        });
        dispatch({
            type: SET_USER, 
            payload: { token },
        });
    } catch (error) {
        dispatch({
            type: LOGIN_ERROR,
        });
    }
};
